import { render, staticRenderFns } from "./AdditionalRoleOffice.vue?vue&type=template&id=62143a3a&scoped=true"
import script from "./AdditionalRoleOffice.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdditionalRoleOffice.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62143a3a",
  null
  
)

export default component.exports